import { Injectable } from "@angular/core";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { MiembroMapper } from "../../utils/mappers/groups/miembros.mapper";
import { Miembro } from "../../utils/types/groups/miembro.type";
import { BaseApiService } from "../shared/base.api.service";

import { MiembroDTO } from "../../utils/types/groups/miembroDTO.type";
import { MIEMBROS_ENDPOINTS } from "../../components/mediaManager/grupos/grupos-endpoints";
import { MiembroCsvDTO } from "../../utils/types/groups/miembroCsvDTO.type";
import { UploadCsvResponse } from "../../utils/types/shared/uploadCsvResponse";
import { map } from "rxjs/operators";
import { of } from "rxjs";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class MiembrosService extends BaseApiService<Miembro> {
    model = Miembro;
    mapper: MiembroMapper = new MiembroMapper();
    apiEndPoint: {
        list: string;
        item: string;
        update: string;
        create: string;
        upload: string;
    } = MIEMBROS_ENDPOINTS;

    getListMiembros(
        groupId: Number,
        filter?: FilterType
    ): Observable<PagedApiResponse<Miembro>> {
        const id = groupId;

        let params = new HttpParams();

        params = params.append("limit", filter.limit.toString());
        params = params.append("offset", filter.offset.toString());

        return this.http
            .post(this.apiEndPoint.list.replace("{id}", id.toString()), null, {
                params,
            })
            .pipe(
                map((res) => {
                    return this.mapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    delete(id: number, otherId: number): Observable<boolean> {
        let URL = this.apiEndPoint.item.replace("{id}", id.toString());
        URL = URL.replace("{groupId}", otherId.toString());

        return this.http
            .delete(URL, {
                observe: "response",
            })
            .pipe(
                map((res) => {
                    if (res.status === 200) {
                        return true;
                    }
                    return false;
                })
            );
    }

    create(data: MiembroDTO): Observable<boolean> {
        delete data.create_date;
        return this.http.post<boolean>(this.apiEndPoint.create, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    update(data: MiembroDTO): Observable<boolean> {
        return this.http.put<boolean>(this.apiEndPoint.update, data);
    }

    uploadCSV(data: any): Observable<UploadCsvResponse> {
        return this.http
            .post<UploadCsvResponse>(this.apiEndPoint.upload, data)
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    processCSV(data: MiembroCsvDTO): Observable<any> {
        console.log("data", data);

        const reader = new FileReader();
        const fileUpload = data.file;
        const formData = new FormData();

        reader.readAsText(fileUpload);

        reader.onloadstart = function (e) {};
        // Reemplazando cambios de linea en el archivo

        return Observable.create((observer) => {
            reader.onload = function (e) {
                // Instanciamos el contenido
                let str_result = reader.result,
                    file_csv;
                // Limpiar cambios de linea
                str_result = str_result
                    .toString()
                    .trim()
                    .replace(/(\r\n|\n|\r)/g, "\n");
                // Reemplaza mas de dos espacios en blanco
                str_result = str_result.replace(/\s{2,}/g, " ");
                str_result = str_result.replace(/\s{1,}\n/g, "\n");
                // Reemplaza mas de dos cambios de linea
                str_result = str_result.replace(/(\n){2,}/g, "\n");

                // Guardamos el nuevo archivo con el contenido corregido y el mismo nombre
                file_csv = new File([str_result], fileUpload.name, {
                    type: "text/csv",
                });

                formData.append("file", file_csv, file_csv.name);

                const grupos: any[] = [
                    {
                        id: data.groups.id,
                        name: data.groups.name,
                        deleteDuplicates: data.groups.deleteDuplicates,
                    },
                ];

                formData.append("groups", JSON.stringify(grupos));

                observer.next(formData);
            };

            reader.onerror = (error) => observer.error(error);
        });
    }
}
